import api from './api';

const BASE = '/api/atl-proyecciones';

const atlProyeccionesService = {
  async list(filters = {}) {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([k, v]) => {
      if (v != null && v !== '') params.set(k, v);
    });
    const qs = params.toString();
    const response = await api.get(`${BASE}${qs ? `?${qs}` : ''}`);
    return response.data?.data || response.data;
  },

  async getById(id) {
    const response = await api.get(`${BASE}/${id}`);
    return response.data?.data || response.data;
  },

  async getComparativo(id) {
    const response = await api.get(`${BASE}/${id}/comparativo`);
    return response.data?.data || response.data;
  },

  async create(payload) {
    const response = await api.post(BASE, payload);
    return response.data?.data || response.data;
  },

  async update(id, payload) {
    const response = await api.put(`${BASE}/${id}`, payload);
    return response.data?.data || response.data;
  },

  async remove(id) {
    const response = await api.delete(`${BASE}/${id}`);
    return response.data;
  },
};

export default atlProyeccionesService;
